Beacon.Account.Homepage = {

    init: function () {
        var self = this;
        self.showUserInfo();
    },

    logout: function () {
        var self = this;

        $.post('/api/authentication/logout').then(function (d) {
            if (d.ok) {
                self.renderUserInfo(false);
            } else {
                alert("failed!");
            }
        });

    },
    showUserInfo: function () {
        var self = this;

        $.post('/api/authentication/status').then(function (d) {
            self.renderUserInfo(d.authenticated, d.Name);
        });
    },

    renderUserInfo: function (authenticated, name) {
        var self = this;

        if (authenticated) {
            $("#username").text(name);
            $(".user-logged-out").hide();
            $(".user-logged-in").show();
        } else {
            $("#username").text('');
            $(".user-logged-in").hide();
            $(".user-logged-out").show();
        }

    },

    CLASS_NAME:"Beacon.Account.Homepage"
};


Beacon.SearchPage = {

    init: function (initialState, initialAreaId) {

        // basic search controls
        $("a[data-search]").click(function () {
            var mode = $(this).data("search");
            $("#txtQuery").attr('name', mode); // set this attribute to set the key in the query string
            switch (mode) {
                case "q":
                    $("#lblQuery").text("Search by name, address, or parcel id");
                    $(this).parents("form").attr('action','/Search');
                    break;
                case "parcelid":
                    $("#lblQuery").text("Search by parcel id");
                    $(this).parents("form").attr('action','/Search/Advanced');
                    break;
                case "alternateid":
                    $('#lblQuery').text('Search by alternate id');
                    $(this).parents('form').attr('action', '/Search/Advanced');
                default:
                    $("#lblQuery").text("Search by " + mode);
                    $(this).parents("form").attr('action','/Search/Advanced');
                    break;
            }

        });


        var ddlState = $("select[name=state]");
        var ddlArea = $("select[name=area]");

        var hashParser = /#state=([^&]+)(?:&area=(.+)){0,1}/i;

        if (window.location.hash) {
            var o = hashParser.exec(window.location.hash);
            if (o.length >= 1) {
                initialState = unescape(o[1]);
            }
            if (o.length >= 2) {
                initialAreaId = unescape(o[2]);
            }
        }


        ddlState.change(function () {
            ChangeState($(this).val());
        });

        ddlArea.change(function () {
            ChangeArea($(this).val());
        });

        $.getJSON('/search/states', function (d) {
            if (initialState) {
                ChangeState(initialState);
            }
            $.each(d, function (p, v) {
                ddlState.append((initialState === v ? "<option selected>" : "<option>") + v + "</option>");
            });
        });

        function ChangeState(state) {
            if (state === '') {
                ddlArea.html('<option value="">ALL</option>');
            } else {
                ddlArea.html('<option value="">ALL</option>');
                $.getJSON('/search/areas', { state: state }, function (d) {
                    $.each(d, function (p, v) {
                        if (initialAreaId == v.id || initialAreaId === v.area) {
                            ddlArea.append("<option value='" + v.id + "' selected>" + v.area + "</option>");
                            initialAreaId = null;
                        } else {
                            ddlArea.append("<option value='" + v.id + "'>" + v.area + "</option>");
                        }
                    });
                });
            }
        }

        function ChangeArea(area) {
        }

        $('form').submit(function (e) {
            var inputs = $('select,input', this);
            $.each(inputs, function (i, el) {
                if (!$(inputs[i]).val()) {
                    el.removeAttribute('name'); // removes from query parameters when blank
                }
            });
        });

    },

    CLASS_NAME: "Beacon.SearchPage"

};